var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center"},[_c('div',{staticClass:"text-center py-10"},[_c('h1',[_vm._v("Service on Available")]),_c('p',[_vm._v(_vm._s(_vm.service)+" is temporarily unavailable. Please check back later.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }